import React, { useEffect } from 'react';

import useServerSideRendering from '@hooks/useServerSideRendering';
import { GoogleOAuthProvider, useGoogleOneTapLogin } from '@react-oauth/google';
import { GOOGLE_CLIENT_ID } from '@src/env';
import { GOOGLE_PROVIDER, createLeadWithOauth } from '@utils/backend-api/oauth';

interface GoogleOneTapProps {
  isGdprRequired: boolean;
  newsletterIds: number[];
  redirectBasePath: string;
  returnTo: string;
}

const DISABLED_PATHS = ['/login', '/subscribe'];

// Keep in sync with OneTap::FORM_LOCATION and OneTap::LEAD_TYPE in app/models/concerns/one_tap.rb
const FORM_LOCATION = 'one_tap_sitewide';
const LEAD_TYPE = 'one_tap_lead';

function GoogleOneTapInner({
  isGdprRequired,
  newsletterIds,
  redirectBasePath,
  returnTo,
}: GoogleOneTapProps) {
  const isDisabled = DISABLED_PATHS.includes(window.location.pathname);

  console.log('[OneTap] GoogleOneTapInner rendered. props:', {
    isGdprRequired,
    newsletterIds,
    redirectBasePath,
    returnTo,
  });
  console.log('[OneTap] Current path:', window.location.pathname, '| isDisabled:', isDisabled);
  console.log('[OneTap] use_fedcm_for_prompt: true (hardcoded)');

  useEffect(() => {
    console.log('[OneTap] GoogleOneTapInner mounted.');
    console.log('[OneTap] window.google present:', !!(window as any).google);
    console.log('[OneTap] window.google.accounts present:', !!(window as any).google?.accounts);
    console.log('[OneTap] google.accounts.id present:', !!(window as any).google?.accounts?.id);
  }, []);

  useGoogleOneTapLogin({
    disabled: isDisabled,
    use_fedcm_for_prompt: true,
    cancel_on_tap_outside: true,
    auto_select: false,
    onSuccess: async (credentialResponse) => {
      console.log('[OneTap] onSuccess fired. credential present:', !!credentialResponse.credential);
      try {
        const payload = {
          id_token: credentialResponse.credential,
          provider: GOOGLE_PROVIDER,
          form_location: FORM_LOCATION,
          lead_type: LEAD_TYPE,
          newsletter_ids: newsletterIds,
          opt_in_required: isGdprRequired,
          declined_opt_in: isGdprRequired,
          page: window.location.pathname,
          redirect_to_on_success: `${redirectBasePath}?return_to=${encodeURIComponent(returnTo)}`,
        };
        console.log('[OneTap] createLeadWithOauth payload:', payload);
        const response = await createLeadWithOauth(payload);
        console.log('[OneTap] createLeadWithOauth response:', response);
        const separator = response.location.includes('?') ? '&' : '?';
        window.location.href = `${response.location}${separator}new=${response.isNewUser}`;
      } catch (error) {
        console.error('[OneTap] createLeadWithOauth failed:', error);
      }
    },
    onError: () => {
      console.error('[OneTap] useGoogleOneTapLogin onError fired');
    },
  });

  return null;
}

export default function GoogleOneTap(props: GoogleOneTapProps) {
  const hydrated = useServerSideRendering();

  console.log(
    '[OneTap] GoogleOneTap outer rendered. hydrated:',
    hydrated,
    '| GOOGLE_CLIENT_ID:',
    GOOGLE_CLIENT_ID ? `set (${GOOGLE_CLIENT_ID.slice(0, 12)}...)` : 'MISSING/EMPTY'
  );

  if (!hydrated) return null;

  return (
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      <GoogleOneTapInner {...props} />
    </GoogleOAuthProvider>
  );
}
